import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { I18nProvider } from './i18n/I18nProvider';
import { initializeAnalytics } from './lib/analytics';
import { SiteApplication } from './site/SiteApplication';
import './styles.css';

const root = document.getElementById('root');

if (root === null) {
    throw new Error('Application root element is missing.');
}

initializeAnalytics();

const pathname = window.location.pathname;
const isToolPath = pathname === '/tool' || pathname.startsWith('/tool/');
const application = isToolPath ? (
    <I18nProvider>
        <App />
    </I18nProvider>
) : (
    <SiteApplication />
);

createRoot(root).render(<StrictMode>{application}</StrictMode>);
